import { ApplyTemplateAction } from "app/actions/applyTemplate";
import SpaceModel from "app/models/SpaceModel";
import TeamGroupModel from "app/models/TeamGroupModel";
import TeamModel from "app/models/TeamModel";
import { RequestError } from "typedefs";

export type ApplyTemplateState = {
  pendingApplyTemplate: boolean;
  errorApplyTemplate: RequestError | null;
  locations: string[];
  spaceObj: SpaceModel[];
  groupObj: TeamModel[];
  groupChannelObj: TeamGroupModel[];
  success: boolean;
};

const initialState: ApplyTemplateState = {
  errorApplyTemplate: null,
  pendingApplyTemplate: false,
  locations: [],
  spaceObj: [],
  groupObj: [],
  groupChannelObj: [],
  success: false,
};

export default function applyTemplateReducer(
  state = initialState,
  action: ApplyTemplateAction,
): ApplyTemplateState {
  switch (action.type) {
    case "@applyTemplate.create.pending":
      return {
        ...state,
        pendingApplyTemplate: true,
        errorApplyTemplate: null,
      };
    case "@applyTemplate.create.error":
      return {
        ...state,
        pendingApplyTemplate: false,
        errorApplyTemplate: action.payload,
      };
    case "@applyTemplate.create.success":
      return {
        ...state,
        success: action.payload,
        errorApplyTemplate: null,
        pendingApplyTemplate: false,
      };
    case "@applyTemplate.fetch.locations":
      return {
        ...state,
        locations: action.payload,
        pendingApplyTemplate: false,
      };
    case "@applyTemplate.fetch.spaceObj":
      return {
        ...state,
        spaceObj: action.payload,
        pendingApplyTemplate: false,
      };
    case "@applyTemplate.fetch.groupObj":
      return {
        ...state,
        groupObj: action.payload,
        pendingApplyTemplate: false,
      };
    case "@applyTemplate.fetch.groupChannelObj":
      return {
        ...state,
        groupChannelObj: action.payload,
        pendingApplyTemplate: false,
      };
    case "@applyTemplate.clear":
      return {
        ...state,
        success: false,
        errorApplyTemplate: null,
        locations: [],
        spaceObj: [],
        groupObj: [],
        groupChannelObj: [],
        pendingApplyTemplate: false,
      };
    default:
      return state;
  }
}
